<template>
  <div>
    <v-toolbar dense style="background-color: #106AC5;" class="border-bottom">
      <a :href="urls.business" target="_blank">
        <img src="/img/aplix-logo-white.png" height="55px" class="ma-0">
      </a>
    </v-toolbar>
    <v-card flat>
      <v-card-media class="white--text" height="250px" src="/img/AprilTag/background.jpg">
        <v-container fill-height>
          <v-layout class="grey--text text--darken-3 mb-0" align-center justify-center row>
            <v-flex sm3 hidden-xs-only></v-flex>
            <v-flex sm12 md6 text-xs-left>
              <h1>groma
                <span class="body-1">&trade;</span>
              </h1>
              <h1>AprilTag</h1>
              <h1>ソリューション</h1>
            </v-flex>
            <v-flex sm12 md6></v-flex>
          </v-layout>
        </v-container>
      </v-card-media>
    </v-card>

    <v-content class="">
      <v-container>
        <!-- ################## AprilTag ソリューションとは ################## -->
        <div>
          <h2 class="colored-title">groma AprilTag <br class="hidden-sm-and-up"> ソリューションとは?</h2>

          <div class="ma-3">
            <v-layout column align-center row wrap class="round-article elevation-3" id="about">
              <h3>ARマーカーを用いた 位置／姿勢情報の取得システム</h3>
              <p>AprilTagはアメリカ ミシガン大学の AprilTags Visual Fiducial System プロジェクトで開発された ARマーカーです。
                <br class="hidden-sm-and-down">マーカーが貼られた物体を撮影することで、3次元空間上の物体の位置や姿勢を迅速かつ正確に取得することができます。
              </p>
              <img
                src="/img/AprilTag/GetInformation.png"
                style="max-width:400px;"
                class="ma-2"
              >
            </v-layout>

            <v-layout column align-center row wrap class="round-article  elevation-3">
              <h3>クラウドで情報を処理・統合</h3>
              <p>この技術をアプリックスが得意とするモバイル・クラウド技術に取り込んだものが、「groma AprilTag ソリューション」です。
                <br class="hidden-sm-and-down">これまでのビーコンによる屋内測位技術・知見を活かしながら、様々なサービスを提供していきます。
              </p>
              <img
                src="/img/AprilTag/UploadInformation.png"
                style="max-width:600px;"
                class="ma-2"
              >
            </v-layout>
          </div>
        </div>
        <!-- // AprilTag ソリューションとは-->

        <!-- ################## News ################## -->
        <div>
          <v-layout wrap align-end justify-center class="mb-0 pb-0" >
            <v-flex sm2 class="hidden-xs-only"></v-flex>
            <v-flex xs12 sm8 class="text-xs-center">
            <h2 >
            <span class="red--text subheading">
              News!
            </span>
              技術拡張をしました！
            </h2>
            </v-flex>
            <v-flex xs12 sm2 class="text-xs-right">
                <span class="subheading grey--text">
                2019.4.25
                </span>
            </v-flex>
          </v-layout>

          <div class="ma-3">
            <v-layout  align-center row wrap class="round-article elevation-3 pb-4 new-feature" id="about">
              <v-flex xs12 sm6 class="pa-1">
                <h3>距離検知</h3>
                <p>
                  ARマーカーが貼られた目的物への距離をより正確に取得できるようになりました。
                </p>
                <img
                  src="/img/AprilTag/new-feature/distance.gif"
                  class="new-gifs"
                >
              </v-flex>
              <v-flex xs12 sm6 class="pa-1">
                <h3>姿勢検知</h3>
                <p>
                  ARマーカーの姿勢(向き)を検知できるようになりました。
                </p>
                <img
                  src="/img/AprilTag/new-feature/orientation.gif"
                  class="new-gifs"
                >
              </v-flex>
              <v-flex xs12 sm6 class="pa-1">
                <h3>角度測定</h3>
                <p>
                  三次元空間内に配置された3点のARマーカーを結ぶ線の二辺の「なす角」を測定できるようになりました。
                </p>
                <img
                  src="/img/AprilTag/new-feature/angle.gif"
                  class="new-gifs"
                >
              </v-flex>
              <v-flex xs12 sm6 class="pa-1" align-self-center  text-xs-center>
                <h3>検知ID数の拡張</h3>
                <p>
                  複数のARマーカーを組み合わせることで、 理論的には無制限の ID 数に対応可能になりました。
                  例えば2×2にARマーカーを並べた場合には、12桁のIDを識別することができます。
                </p>
                <img
                  src="/img/AprilTag/new-feature/expand-id.gif"
                  class="new-gifs"
                >
              </v-flex>
            </v-layout>
          </div>
        </div>
        <!-- // AprilTag ソリューションとは-->

        <!-- ################## ソリューション例 ################## -->
        <div class="mt-5">
          <h2 class="mb-0">自由にお試しいただける <br class="hidden-sm-and-up"> iOS アプリ</h2>
          <div class="ma-3">
            <v-layout column align-center row wrap class="round-article  elevation-3" id="Quanti">
              <!-- Quanti logo -->
              <p class="mb-0 ma-1">カメラをかざすと <br class="hidden-sm-and-up"> 書類や在庫がすぐ見つかる</p>
              <img src="/img/AprilTag/Quanti-text.png" width="100px" class="mb-3">
              
              <img
                src="/img/AprilTag/Quanti.gif"
                class="ma-2 img-border"
                style="max-width:300px;"
              >
              <p>探しているものをすぐに見つけられないことにお困りではありませんか？
                <br class="hidden-sm-and-down">似たようなものの中から特定のものを探し出すために費やす時間は、非常に無駄なものです。
                <br class="hidden-sm-and-down">アプリックスが開発したiPhone/iPadアプリ、「Quanti (クアンティ) 」を使えば、
                <br class="hidden-sm-and-down">指定したIDのマーカーが貼られているものを迅速に探し出すことができます。
              </p>

              <!-- Quanti 使用写真 -->
              <h3 class="text-border mt-3">実際の使用例</h3>
              <p>使い方は簡単。マーカーをダウンロードし、管理したいものに貼り付け、
                <br class="hidden-sm-and-down">お持ちのiPhoneまたはiPadでかざしてみるだけです。
                <br class="hidden-sm-and-down">
              </p>

              <!--
              <img src="/img/AprilTag/Quanti.gif" style="max-width:300px;" >
              -->
              <img
                src="/img/AprilTag/shelf.gif"
                style="max-width:300px;"
                class="img-border"
              >
              <p>ご利用は無料です。
                <br class="hidden-sm-and-up">お気軽にお試しください。
              </p>
              <a :href="appStore.href" target="_blank" :style="appStore.style"></a>
              <v-btn
                href="./AprilTag/download"
                target="_blank"
                color="white"
                class="mt-4 mb-3 caption"
                style="border:1px solid #666!important;text-transform:none;"
              >マーカーの表示・
                <br class="hidden-sm-and-up">ダウンロードはこちら&nbsp;
                <v-icon class="caption">open_in_new</v-icon>
              </v-btn>
            </v-layout>
          </div>
        </div>
        <!--ソリューション例-->
        <!-- ################## お問い合わせ ################## -->
        <div class="mt-5">
          <h2 class="mb-0">ご相談・お問い合わせ</h2>
          <div class="ma-3">
            <v-layout column align-center row wrap class="round-article  elevation-3" id="contact">
              <p>groma AprilTag ソリューションを利用したサービスを作りませんか？
                <br class="hidden-xs-only">アプリックスではカスタマイズ案件も承っております。
                <br class="hidden-xs-only">「位置や姿勢情報をクラウドで管理したい」「Quantiを自社システムに組み込みたい」等、
                <br class="hidden-xs-only">お気軽にお問い合わせください。
              </p>
              <a href="https://www.aplix.co.jp/inquiry/product/" target="_blank">ご相談・お問い合わせページはこちら</a>
            </v-layout>
          </div>
        </div>
        <!--お問い合わせ-->
        <!-- ################## 免責事項 ################## -->
        <div class="mt-5">
          <div class="ma-3">
            <v-layout column align-center row wrap class="round-article  elevation-3" id="contact">
              <p>「groma」は屋内測位／位置情報システム市場を主な対象とする社内研究開発プロジェクト名であり、<br>
              「Quanti」はgromaに属するサンプルアプリケーション名です。<br>
              いずれもアプリックスにおける研究開発活動の成果のひとつであり、<br>
              単独の商品またはサービスとしてご提供するものではなく、<br>
              お客様の要望に応じてご提供するソリューションに要素技術として含まれるものです。
              </p>
            </v-layout>
          </div>
        </div>
        <!--免責事項-->

      </v-container>

      <!-- ################## groma とは ################## -->
      <v-layout column align-center row wrap class="pa-4 grey lighten-5" id="groma">
        <img src="/img/groma.png" style="max-width:120px;">

        <p class="mb-0">groma&trade; はアプリックスの屋内測位／位置情報システム市場向けソリューションです。
          <br>
        </p>
        <span class="grey--text caption">※ 記載されている会社名、製品名は各社の商標または登録商標です。</span>
      </v-layout>
    </v-content>

    <!-- ################## フッター ################## -->
    <v-footer class="white--text pa-0" height="auto" style="background-color: #106AC5;">
      <v-layout row wrap class="mb-0">
        <v-flex>
          <v-btn color="white" flat small :href="urls.aplix" target="_blank">会社概要</v-btn>
        </v-flex>
        <v-flex>
          <v-btn color="white" flat small :href="urls.privacy" target="_blank">個人情報保護方針</v-btn>
        </v-flex>
        <v-flex>
          <v-btn color="white" flat small :href="urls.norm" target="_blank">行動規範</v-btn>
        </v-flex>
        <v-flex>
          <v-btn color="white" flat small :href="urls.eula" target="_blank">使用許諾契約(EULA)</v-btn>
        </v-flex>
        <v-flex>
          <v-btn
            color="white"
            flat
            small
            :href="DEPLOY_MODE!='production'?
            'https://github.com/Aplix-ip/groma-AprilTag':
            'https://github.com/AplixCorporation/groma-AprilTag'"
            target="_blank"
          >GitHub</v-btn>
        </v-flex>
        <v-flex xs12 text-xs-right class="pa-2 footer-copyright">
          <span>Copyright &copy; 2018 Aplix and/or its affiliates. All rights reserved.</span>
        </v-flex>
      </v-layout>
    </v-footer>
  </div>
</template>

<script>
export default {
  name: "AprilTag",
  metaInfo: {
    title: "groma | AprilTag"
  },
  components: {
    //customerform: CustomerForm
  },
  data() {
    return {
      DEPLOY_MODE: process.env.DEPLOY_MODE,
      urls: {},
      urlsForJa: {
        aplix: "https://www.aplix.co.jp/corp/",
        business: "https://business.aplix.co.jp",
        eula: "https://www.aplix.co.jp/legal/terms_eula.php",
        privacy: "https://www.aplix.co.jp/privacypolicy/",
        norm: "https://www.aplix.co.jp/norm/"
      },
      urlsForEng: {
        aplix: "https://www.aplix.co.jp/en/corp/",
        business: "https://business.aplix.co.jp/en/",
        eula: "https://www.aplix.co.jp/en/legal/terms_eula.php",
        privacy: "https://www.aplix.co.jp/en/privacypolicy/",
        norm: "https://www.aplix.co.jp/en/norm/"
      },
      appStore: {},
      appStoreForJa: {
        href: "https://itunes.apple.com/jp/app/quanti/id1434028363?mt=8",
        style:
          "display:inline-block;overflow:hidden;background:url(https://linkmaker.itunes.apple.com/assets/shared/badges/ja-jp/appstore-lrg.svg) no-repeat;width:135px;height:40px;"
      },
      appStoreForEng: {
        href: "https://itunes.apple.com/us/app/quanti/id1434028363?mt=8",
        style:
          "display:inline-block;overflow:hidden;background:url(https://linkmaker.itunes.apple.com/assets/shared/badges/en-us/appstore-lrg.svg) no-repeat;width:135px;height:40px;"
      }
    };
  },
  methods: {
    setURLwithLang() {
      var newLang = WOVN.io.getCurrentLang().code;
      if (newLang == "ja") {
        this.urls = this.urlsForJa;
        this.appStore = this.appStoreForJa;
      } else {
        this.urls = this.urlsForEng;
        this.appStore = this.appStoreForEng;
      }
    }
  },
  created() {
    //取り急ぎの格納
    this.urls = this.urlsForJa;
    this.appStore = this.appStoreForJa;
  },
  mounted() {
    // WOVNが準備できたら言語によってURLの変更
    window.addEventListener("wovnApiReady", this.setURLwithLang);
    // WOVNの言語変更を検知するリスナーの追加
    window.addEventListener("wovnLangChanged", this.setURLwithLang);
  }
};
</script>

<style scoped>
.footer-copyright {
  background-color: #0059b2;
}
.round-article {
  border-radius: 10px;
  border: #116AC5 1px solid;
  padding: 20px 10px 10px 10px;
  margin-bottom: 20px;
  background-color: #fff;
}
.text-border {
  border-bottom: #388dbf 3px double;
}
.img-border {
  border: 1px solid #bbb;
}
.new-gifs{
  border: 1px solid #bbb;
  border-radius: 10px;
  max-width:300px;width:100%;
}

.new-feature p{
  line-height:1.5;
  max-width:400px;
  width:100%;
  margin:0 auto;
}

h2,
h3,
p {
  margin-top: 10px;
}
p {
  line-height: 28px;
}
.v-carousel {
  max-width: 350px;
  height: 250px;
  box-shadow: none;
}

.freebirdHeaderMast {
  height: 100px !important;
}
hr {
  border-top: #cccccc solid 0.1px;
}
.v-footer .v-btn {
  text-transform: none;
}
.colored-title {
  color: #0059b2;
}
</style>

<style>
.v-jumbotron__image {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/AprilTag/AprilTagIndex.vue